import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getSampleReturnList = createAsyncThunk(
  "get-sample-return",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("product/sample/return/list", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const sampleReturnSlice = createSlice({
  name: "sample",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSampleReturnList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSampleReturnList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.sampleListReturn ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getSampleReturnList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default sampleReturnSlice.reducer;
